import BaseApi, { FetchMethodType } from 'api/BaseApi';
import { VariableValue } from 'api/types';

export enum ButtonType {
  Primary = 'primary',
  Secondary = 'secondary',
}

export interface ISubmitPageParams {
  buttonsElementId: string;
  buttonType: ButtonType;
  applicationDisplayId: string;
  data?: Record<string, VariableValue>;
}

interface IPortalPageInfoApi {
  submit(params: ISubmitPageParams): Promise<void>;
}

export default class PortalPageInfoRestApi extends BaseApi implements IPortalPageInfoApi {
  public submit(params: ISubmitPageParams): Promise<void> {
    return this.fetch('/portal-page-info', {
      method: FetchMethodType.POST,
      body: params,
    });
  }
}
